import { ChangeDetectionStrategy, Component, inject, signal, Signal, WritableSignal } from '@angular/core';
import { GetUserCommentQueryHandler, GetUserCommentQueryResult } from '../../application/handlers';
import { commentMapper } from '../../application/utils';
import { CommentModel } from '../../application/interfaces';
import { CommentTypeEnum } from '@core-http';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-user-comments',
  templateUrl: './user-comments.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [GetUserCommentQueryHandler]
})
export class UserCommentsComponent {
  private readonly getUserCommentQueryHandler: GetUserCommentQueryHandler = inject(GetUserCommentQueryHandler);

  readonly commentMapper: Record<CommentTypeEnum, CommentModel> = commentMapper;
  readonly isExpanded: WritableSignal<boolean> = signal<boolean>(false);

  readonly comments: Signal<GetUserCommentQueryResult | undefined> = toSignal(
    this.getUserCommentQueryHandler.getComment()
  );

  changeVisibility(): void {
    this.isExpanded.update((value: boolean) => !value);
  }
}
